import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CareersSection from "../components/Careers/CareersSection";
import CareerForm from "../components/Careers/CareerForm";
import CareersFAQ from "../components/Careers/CareersFAQ";
import AboutBanner from "../components/AboutBanner";
import CareerOpenings from "../components/Careers/CareerOpenings";


function Offers() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };


  return (
    <>
    <Header />
    <AboutBanner
  title="Career"
  subtitle="Join CM Green Energy India Private Limited"
/>
    <CareersSection />
    <CareerOpenings />
    <CareerForm />
    <CareersFAQ />
    <Footer /> 
    </>
  );
}

export default Offers;
